import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getVariationMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getVariationMasterListApi = createAsyncThunk('getVariationMasterList', async (payload) => {
  // console.log('payload', payload);
  return await getVariationMasterApi(payload);
});

const getVariationMasterListSlice = createSlice({
  name: 'getVariationMasterList', // Unique Name
  initialState,
  reducers: {
    getVariationMasterListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVariationMasterListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getVariationMasterListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getVariationMasterListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getVariationMasterListReset } = getVariationMasterListSlice.actions;

export default getVariationMasterListSlice.reducer;
